import React, { useEffect } from "react"
import { useTransition, animated } from "@react-spring/web"
import * as styles from "./prepare.module.scss"
import { pageUrl } from "@config"
import { trackHasData } from "@utils/sensors"
import { platformCheck, postAppMsg } from "@src/utils/request"
// import LottieControl from "../lottie"
// import loadingJson from "@images/lottieJson/loading.json"
import Button from "../button"
import loadingImg from "@images/2022/p2/11.png"

const Preparing = ({ isMobile, needSignin, loading, loaded, data }) => {
  const checkingMobile = typeof isMobile === "undefined"
  const visible = loading || needSignin || checkingMobile
  const transitions = useTransition(visible, {
    from: { opacity: 1 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    // delay: 2000, //https://github.com/pmndrs/react-spring/issues/1662
  })

  useEffect(() => {
    if (loaded) {
      trackHasData("data")
    } else if (data === null) {
      trackHasData("error")
    }
  }, [data, loaded])

  const jumpToSignin = () => {
    platformCheck(
      () => {
        postAppMsg("navigate", {
          link: "app://gcores.Signin",
        })
      },
      () => {
        window.location.href = `https://www.gcores.com/account/signin?return=${encodeURIComponent(
          pageUrl
        )}`
      }
    )
  }

  useEffect(() => {
    if (needSignin) {
      if (window.confirm("请先登录以查看年度报告，是否跳转到登录页？")) {
        jumpToSignin()
      }
    }
  }, [needSignin])

  let body = (
    <img src={loadingImg} alt="loading" className={styles.loadingIcon} />
  )
  if (needSignin) {
    body = (
      <div>
        <Button
          onClick={() => {
            jumpToSignin()
          }}
        >
          请先登录
        </Button>
      </div>
    )
  }

  return transitions(
    (props, item) =>
      item && (
        <animated.div style={props} className={styles.container}>
          <div className={styles.body}>{body}</div>
        </animated.div>
      )
  )
}

export default Preparing
